import SingleSelectField from 'fields/SingleSelectField';

import { useTranslation } from 'react-i18next';
import { CROP_PRODUCT_TYPES_OPTIONS } from 'appConstants';
import { useField } from 'formik';
import { useCallback } from 'react';

const ProductType = () => {
  const { t } = useTranslation('CreateCropOrder', { keyPrefix: 'ProductForm' });
  const [{ value: packagedItemReference }, , { setValue }] = useField('packagedItemReference');

  const handleChange = useCallback(async () => {
    if (packagedItemReference) await setValue('');
  }, [packagedItemReference, setValue]);

  return (
    <SingleSelectField
      onChange={handleChange}
      data-testid="product-type-field"
      name="productType"
      label={t('labels.productType')}
      placeholder={t('placeholders.productType')}
      options={CROP_PRODUCT_TYPES_OPTIONS}
    />
  );
};
export default ProductType;
